module.exports = __webpack_public_path__ + "img/Speaker=Priya Ghose.5c91b347.png";